<template>
  <div class="agreementPage">
    <p>尊敬的用户，您好！</p>
    <p>
      为促进优秀文化成果的传播利用，规范数字作品的使用，推动中国数字出版的发展，尊重著作权人的劳动成果，经甲乙双方当事人协商一致，签订本授权书。
    </p>
    <p>一、授权事项及双方权利义务</p>
    <p>
      1、甲方将个人作品在龙源区块链确权平进行版权登记，每篇文章可获得：确权证书+版权证书，每篇文章的版权登记费用为：60元（确权证书10元+版权证书50元）。
    </p>
    <p>
      2、根据本合同出版发行的作品不得含有下列内容：
      （一）反对宪法确定的基本原则；
    </p>
    <p>（二）危害国家统一、主权和领土完整； （三）危害国家安全、荣誉和利益；</p>
    <p>（四）煽动民族分裂，侵害少数民族风俗习惯，破坏民族团结；</p>
    <p>（五）泄露国家机密；</p>
    <p>（六）宣扬淫秽、迷信或者渲染暴力，危害社会公德和民族优秀文化传统；</p>
    <p>（七）侮辱或者诽谤他人；</p>
    <p>（八）法律、法规规定禁止的其他内容。</p>
    <p>
      3、乙方负责组建专门营销团队及运营团队，负责甲方授权内容的产品研发和数字发行。其中包括数字格式的数据加工、技术平台支撑、支付平台技术支持和营销推广。
    </p>
    <p>
      4、甲方授权乙方进行授权作品维权，乙方有权采取措施制止第三方侵犯甲方授权作品，并代理甲方进行维权，维权收入（扣除公证费、律师费、诉讼费等支出后）双方按50%进行分配。
    </p>
    <p>
      5、为促进授权文章的销售，增强个人品牌影响力，甲方应在本协议签署后，甲方授权乙方可将相关授权转让给第三方使用，乙方向甲方支付报酬为收益分成比例的50%。
    </p>
    <p>
      6、甲方可以随时要求乙方从区块链平台中查询甲方作品的阅读次数等相关统计数据。
    </p>
    <p>二、违约责任</p>
    <p>
      1、甲乙双方任何一方违反授权书义务，给对方造成损失的，应负相应的赔偿责任。
    </p>
    <p>2、其他违约责任按有关法律、法规规定处理。 三、生效时间及纠纷解决</p>
    <p>1、本授权书自当事人双方签字之日起生效。</p>
    <p>
      2、本授权书的有效期为三年，期满后三个月内双方无异议（异议须书面形式），本授权自动延续。
    </p>
    <p>3、发生纠纷时由甲乙双方以友好协商的方式解决。</p>
    <div class="readingOk" @click="readingOk">确认阅读</div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";

export default {
  name: "agreementPage",
  setup() {
    const router = useRouter();
    // let pageData = reactive({});
    function readingOk() {
      router.go(-1)
    }
    return {
      readingOk,
    };
  },
};
</script>
<style lang="scss" scoped>
.agreementPage {
  width: 790px;
  margin: 30px auto;
  p {
    margin: 10px 0;
  }
  .readingOk {
    width: 240px;
    height: 40px;
    font-size: 14px;
    font-family: AlibabaPuHuiTiM;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    background: #008aea;
    border-radius: 8px;
    cursor: pointer;
    margin-top: 50px;
  }
  .readingOk:hover {
    background: #6dbbfc;
    transition: 0.4s all;
  }
}
</style>
